import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TagsService extends BaseService {

  constructor(protected override http: HttpClient, protected override router: Router) {
    super(http, router);
  }

  checkNameExist(resourceType: string, query?: any) {
    const queryStr = this.objectToQueryString(query);
    const url = `/tags/${resourceType}/check/name?${queryStr}`;
    return super.get(url);
  }


  deleteItem(resourceType: string, data: any) {
    return this.post(`/tags/${resourceType}/item/delete`, data);
  }

  save(resourceType: string, data: any) {
    return this.post(`/tags/${resourceType}/item/save`, data);
  }

  updateItemSeq(resourceType: string, data: { syllabus_id: number; seq: [number, number][] }) {
    return this.post(`/tags/${resourceType}/rel/item-seq`, data);
  }

  moveItem(resourceType: string, data: { item_id: number; to_syllabus_id: number; from_syllabus_id?: number }) {
    return this.post(`/tags/${resourceType}/rel/move-item`, data);
  }

  removeFromFolder(resourceType: string, data: { item_id: number; syllabus_id: number }) {
    return this.post(`/tags/${resourceType}/rel/remove-from-folder`, data);
  }



}
